/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { TextField as FormikTextField } from "formik-material-ui";
import TextField from "@mui/material/TextField";
import { Grid } from "@mui/material";
import Spinner from "react-spinner-material";
import REACT_APP from "../../environment";
import axios from "axios";
import regex from "tts-hrp-val-lib";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

export default function UpdateLibrary({ id, name, acceptance_date, handleMenuClose, getAllFiles }) {
    const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [acceptanceDate, setAcceptanceDate] = React.useState(acceptance_date);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const validation = Yup.object({
        name: Yup.string().required("Name is required"),
        acceptance_date: Yup.date().nullable(),
    });

    const onUpdate = async (values) => {
        const data = { id: values.id, name: values.name, acceptance_date: acceptanceDate };
        setLoading(true);
        await axios
            .put(`${REACT_APP.URL}/api/hrp/tts/adm/library-file`, data, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("token"),
                    "client-id": REACT_APP.CLIENTID,
                    "client-secret": REACT_APP.SECRET,
                },
            })
            .then(async (res) => {
                await getAllFiles();
                setLoading(false);
                toast.success("Success!", { autoClose: 2000 });
                handleClose();
                handleMenuClose();
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                toast.error("An error occurred");
            });
    };

    return (
        <div className="addhotel">
            <Button onClick={handleOpen}>Update</Button>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{ backdrop: { timeout: 500 } }}
            >
                <Fade in={open}>
                    <Box sx={style} className="addhotelmodal">
                        <Typography id="transition-modal-title" variant="h6" component="h2" className="marginBottom">
                            Enter library file information
                        </Typography>
                        <Formik
                            initialValues={{ id, name, acceptance_date: acceptanceDate }}
                            validationSchema={validation}
                            onSubmit={async (values) => {
                                onUpdate(values);
                                return new Promise((res) => setTimeout(res, 500));
                            }}
                        >
                            {({ values, errors }) => (
                                <Form autoComplete="off" className="mt-4">
                                    <Grid container spacing={4}>
                                        <Grid item xs={12} className="marginBottom">
                                            <Field fullWidth label="Name" name="name" component={FormikTextField} autoComplete="off" type="text" />
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={12} className="marginBottom">
                                            <TextField
                                                fullWidth
                                                type="date"
                                                name="acceptance_date"
                                                InputLabelProps={{ shrink: true }}
                                                onChange={(e) => setAcceptanceDate(e.target.value)}
                                                defaultValue={acceptanceDate ? new Date(acceptanceDate).toISOString().slice(0, 10) : null}
                                                label="Acceptance Date"
                                            />
                                        </Grid>
                                    </Grid>
                                    <div className="left_right">
                                        <Button onClick={handleClose} variant="contained" sx={{ mt: 3, mb: 2 }} color="error">
                                            Close
                                        </Button>
                                        {loading ? (
                                            <LoadingButton loading variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                Update
                                            </LoadingButton>
                                        ) : (
                                            <Button type="submit" className="mt-5" variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                Update
                                            </Button>
                                        )}
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
